<template>
    <div class="page-option page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">操作权限管理</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>系统管理</el-breadcrumb-item>
                            <el-breadcrumb-item>操作权限管理</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleOption('add')">添加 <i class="el-icon-plus"></i></el-button>
                   <!-- <el-button type="primary" class="btn-bg-rm" @click="delmultiple()">批量删除</el-button>-->
                </el-col>
            </el-row>
            <div class="bd">
                <!--<div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item label="状态：">
                            <el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.status_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>-->
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" :indent="15" style="width: 100%;text-align: center;" row-key="id" default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                            <el-table-column prop="name" label="操作权限名称" min-width="220">
                            </el-table-column>
                            <el-table-column prop="id" width="55" label="ID" align="center">
                            </el-table-column>
                            <el-table-column prop="p_operate_name" align="center" label="上级权限" min-width="120">
                            </el-table-column>
                            <el-table-column prop="url" align="center" label="操作权限地址" min-width="240">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.url"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sort" align="center" label="排序" min-width="120">
                            </el-table-column>
                            <el-table-column prop="status_name" align="center" label="状态" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="description" align="center" label="描述" min-width="180">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.description"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleOption('edit',scope.row)">编辑</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteOption(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export option-dialog" :title="dlg_option.title" :visible.sync="dlg_option.visible" width="554px" @close="closeOption" :close-on-click-modal="false">
            <el-form ref="formOption" :model="dlg_option.form" label-width="130px" :rules="dlg_option.rules" @submit.native.prevent>
                <el-form-item prop="name" style="margin-top: 15px;" label="操作权限名称：" :error="dlg_option.error.name">
                    <el-input size="small" v-model="dlg_option.form.name" placeholder='请输入操作权限名称' clearable></el-input>
                </el-form-item>
                <el-form-item prop="url" label="操作权限地址：" :error="dlg_option.error.url">
                    <el-input size="small" v-model="dlg_option.form.url" placeholder='请输入操作权限地址' clearable></el-input>
                </el-form-item>
                <el-form-item  prop="p_id" label="上级权限：">
                    <el-select size="small" v-model="dlg_option.form.p_id" placeholder="请选择" >
                        <el-option
                                v-for="item in dlg_option.init_data.parent_list"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="sort" label="排序：">
                <el-input size="small" type='number' v-model="dlg_option.form.sort" placeholder='请输入排序（输入数字）' clearable></el-input>
                </el-form-item>
                <el-form-item prop="status" label="状态：">
                    <el-radio-group v-model="dlg_option.form.status">
                        <el-radio v-for="(item, index) in dlg_option.init_data.status_list" :key="index" :label="item.id">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="description" label="描述：">
                    <el-input v-model="dlg_option.form.description" type="textarea" :rows="3" size="small" placeholder="请输入描述"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_option.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitOption()" :loading="dlg_option.btn_loading">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
            <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                drawer: false,
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                //搜索
                /*form_search:{
                    status: -1
                },
                init_data: {
                    status_list: [{id:-1, name: '全部'},{id:1, name: '开启'},{id:2, name: '禁用'}],
                },*/
                //multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                },
                dlg_option:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
                    hide_upload: false,
                    img_list: [],
                    form:{
                        name:'',
                        url:'',
                        p_id:0,
                        sort:'',
                        status:1,
                        description:''
                    },
                    error:{
                        name:'',
                        url:''
                    },
                    reset_form: {},
                    init_data:{
                        status_list: [{id:1, name: '开启'},{id:2, name: '禁用'}],
                        parent_list:[]
                    },
                    params:{
                        action: 'https://jsonplaceholder.typicode.com/posts/',
                        data:{token:localStorage.getItem('token')}
                    },
                    rules:{
                        name:{required: true, message: '请输入操作权限名称', trigger: ['change','blur']},
                        sort:{required: true, message: '请输入排序（输入数字）', trigger: ['change','blur']}
                    }
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = '操作权限管理';
            this.dlg_option.reset_form = Object.assign({}, this.dlg_option.form);
            this.getList();
        },
        methods: {
            getList() {
                var _this = this;
                _this.table_data.loading = true;
                var operate_top = [{id:0, name: '顶级'}];
                this.$client.get('/adminapi/adminoperate/list', {}, function(res,message){
                    _this.table_data.list = res.list;
                    _this.dlg_option.init_data.status_list = res.status_name_list;
                    _this.dlg_option.init_data.parent_list = operate_top.concat(res.operate_top_list);
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleOption(type,data){
                this.dlg_option.visible = true;
                if(type == 'add'){
                    this.dlg_option.title = '添加操作权限';
                    this.dlg_option.api = '/adminapi/adminoperate/save';
                }else{
                    this.dlg_option.id= data.id;
                    this.dlg_option.title = '编辑操作权限';
                    this.dlg_option.form.name = data.name;
                    this.dlg_option.form.url = data.url;
                    this.dlg_option.form.p_id = data.p_id;
                    this.dlg_option.form.sort = data.sort;
                    this.dlg_option.form.description = data.description;
                    this.dlg_option.form.status = data.status;
                    if(data.icon){
                        this.dlg_option.img_list = [{name: data.name, url: data.icon}];
                        this.dlg_option.hide_upload = true;
                    }else{
                        this.dlg_option.img_list = [];
                        this.dlg_option.hide_upload = false;
                    }
                    this.dlg_option.api = '/adminapi/adminoperate/save?id=' + data.id;
                }
            },
            deleteOption(id){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/adminoperate/delete', {id:id}, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            submitOption(){
                var _this = this;
                _this.$refs['formOption'].validate((valid) => {
                    if (valid) {
                        this.dlg_option.btn_loading = true;
                        this.$client.post(this.dlg_option.api, this.dlg_option.form, function(res,message){
                            //console.log(res)
                            _this.$message(message);
                            _this.getList();
                            _this.dlg_option.btn_loading = false;
                            _this.dlg_option.visible = false;
                        }, function(message){
                            _this.dlg_option.btn_loading = false;
                            if((typeof message)==='object'){
                                console.log(111)
                                for(var key in message){
                                    _this.dlg_option.error[key] = message[key];
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            closeOption(){
                for(var key in this.dlg_option.form){
                    this.dlg_option.form[key] = this.dlg_option.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formOption.clearValidate();
            })
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-227)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>
    .el-drawer__header{
        margin-bottom: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #e9e9e9;
    }
    .el-drawer,.el-drawer__header,.el-drawer__header>:first-child{
        outline: none !important;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }
    .page-option .el-upload--picture-card{
        line-height: 80px;
    }
    .page-option .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 80px;
        height: 80px;
    }

    .domain-dialog .el-form-item__label:before,.forward-dialog .el-form-item__label:before{
        display: none;
    }
    .approve-dialog .el-dialog__footer{
        text-align: center;
    }
    .error-dialog .el-dialog__header{
        border-bottom: none;
        padding-top: 25px;
        text-align: center;
    }
</style>
<style scoped>
    .tips{
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        color: #ff5555;
    }
</style>